<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     我的线索
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="prm-clue padding-footer">
    <div class="filter-container">
      <div class="filter-box">
        <span class="filter-item">
          <f-radio-btn-group v-model="query.status" :groups="clientsTypeArr" @change="fetchData(1)" />
        </span>
        <div class="filter-item sm">
          <el-select v-model="query.intention_level" placeholder="意向等级" clearable style="width: 160px;" @change="fetchData(1)">
            <el-option v-for="item in intentionLevelArr" :key="item.value" :label="item.title" :value="item.value" />
          </el-select>
        </div>
        <div class="filter-item">
          <f-date-range-picker v-model="listTime" :shortcuts="['this-week', 'last-week', 'this-month', 'last-month', 'last-last-month']" @change="fetchData(1)" />
        </div>
        <div class="filter-item sm">
          <f-search-input v-model="query.keyword" width="160" placeholder="名称 / 描述" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
      </div>
      <div class="toolbox">
        <el-button type="primary" icon="el-icon-plus" @click="clueReportShow = true">新线索</el-button>
        <f-sort-selector v-model="query.sortby" :options="sortOptions" class="ml" @change="sortChange" />
      </div>
    </div>
    <el-card v-loading="loading" shadow="never" class="card mb-md">
      <el-table ref="listTable" :data="list" tooltip-effect="dark">
        <el-table-column type="index" width="50" label="#" />
        <el-table-column width="60">
          <div class="cube flex-center text-purple radius5" slot-scope="scope">
            <div class="iconfont icon-clue"></div>
          </div>
        </el-table-column>

        <el-table-column label="名称" min-width="220">
          <div slot-scope="scope" class="company-box">
            <div class="mb-xs">{{ scope.row.company_name }}</div>
            <span class="text-muted font-sm">{{ scope.row.credit_code }}</span>
          </div>
        </el-table-column>
        <el-table-column label="状态" min-width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.detail_status == 10" type="warning">待审核</el-tag>
            <el-tag v-else-if="scope.row.detail_status == 11" type="warning">审验中</el-tag>
            <el-tag v-else-if="scope.row.detail_status == 20" type="success">线索保护中</el-tag>
            <el-tag v-else-if="scope.row.detail_status == 30" type="success" effect="dark">已转化成交</el-tag>
            <el-tag v-else-if="scope.row.detail_status == 50" type="danger">已驳回</el-tag>
            <el-tag v-else-if="scope.row.detail_status == 51" type="info">已取消</el-tag>
            <el-tag v-else-if="scope.row.detail_status == 52" type="info">已放弃</el-tag>
            <el-tag v-else-if="scope.row.detail_status == 53" type="danger">已释放</el-tag>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="意向等级" min-width="100">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <i v-if="scope.row.intention_level == 1" class="iconfont icon-circle-outline text-blue" style="font-size: 20px;"></i>
              <i v-else-if="scope.row.intention_level == 2" class="iconfont icon-circle-outline text-warning" style="font-size: 20px;"></i>
              <i v-else-if="scope.row.intention_level == 3" class="iconfont icon-circle-outline text-danger" style="font-size: 20px;"></i>
              <span class="text-black ml-sm" style="line-height: 1;">{{ intentionLevelObj[scope.row.intention_level] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="线索描述" min-width="100" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.description" popper-class="prm-clue-tooltip-description" placement="top">
              <template slot="content">
                <el-scrollbar style="max-height: 400px;">
                  <div class="prm-clue-tooltip-description-content">
                    {{ scope.row.description }}
                  </div>
                </el-scrollbar>
              </template>
              <i class="el-icon-chat-dot-round font-2x text-muted"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="报备日期" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d}') }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="保护期至" min-width="140">
          <template slot-scope="scope">
            <div v-if="now > scope.row.protection_expiretime" class="text-danger">{{ scope.row.protection_expiretime | parseTime('{y}/{m}/{d}') }}<span class="ml-sm">已到期</span> </div>
            <div v-else-if="scope.row.protection_expiretime - now <= 7 * 24 * 3600" class="text-warning">{{ scope.row.protection_expiretime | parseTime('{y}/{m}/{d}') }}<span class="ml-sm">剩余7天</span></div>
            <div v-else>{{ scope.row.protection_expiretime | parseTime('{y}/{m}/{d}') }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope"></template>
        </el-table-column>

        <template slot="append">
          <div class="foot-menu" :class="!collapse && 'active'">
            <div class="foot">
              <f-table-footer>
                <template slot="right">
                  <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
                </template>
              </f-table-footer>
            </div>
          </div>
        </template>

        <div v-if="!loading" slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt class="no-data" />
          </div>
        </div>
      </el-table>
    </el-card>

    <clue-report v-if="clueReportShow" :show.sync="clueReportShow" :company="company" @success="fetchData" @exist="clueExist" />

    <record-check v-if="recordShow" :show.sync="recordShow" :companyid="companyid" type="dialog" @report="toClueReport" />
  </div>
</template>

<script>
import { getLeadListApi } from "@/api/prm/prmClueApi"

export default {
  name: "PrmClue",
  data() {
    return {
      clientsTypeArr: [
        { value: 0, title: "全部", separate: true },
        { value: 10, title: "审核" },
        { value: 20, title: "有效" },
        { value: 30, title: "成交" },
        { value: 50, title: "无效" },
      ],
      sortOptions: [
        { value: 1, title: "最近报备" },
        { value: 2, title: "最早报备" },
        { value: 4, title: "最早到期" },
        { value: 3, title: "最晚到期" },
      ],
      loading: false,
      total: 0,
      query: {
        status: 0,
        intention_level: null,
        sortby: +localStorage.getItem('__PRM_CLUE_SORT__') || 1,
        keyword: '',
        memberid: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
      },
      list: [],
      listTime: [],
      clueReportShow: false,
      recordShow: false,
      companyid: '',
      company: {},
    }
  },
  components: {
    ClueReport: () => import('./components/ClueReport'),
    RecordCheck: () => import('./components/RecordCheck'),
  },
  mounted() {
    this.fetchData(1)
  },
  computed: {
    authObj() {
      return this.$store.getters.authObj
    },
    intentionLevelObj() {
      return this.$store.getters.intentionLevelObj
    },
    intentionLevelArr() {
      return this.$store.state.prmStore.intentionLevelArr
    },
    now() {
      return parseInt(new Date().getTime() / 1000)
    },
    collapse() {
      return this.$store.state.commonStore.collapse;
    }
  },
  methods: {
    fetchData(page) {
      if (page) {
        this.query.pindex = page
      }
      this.loading = true
      const params = {
        ...this.query,
        starttime: this.listTime ? this.listTime[0] : '',
        endtime: this.listTime ? this.listTime[1] : '',
      }
      getLeadListApi(params).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    sortChange(val) {
      this.query.sort = val.value
      localStorage.setItem('__PRM_CLUE_SORT__', val.value)
      this.fetchData(1)
    },

    clueExist(id) {
      this.companyid = id
      setTimeout(() => {
        this.recordShow = true
      }, 500)
    },

    toClueReport(company) {
      this.company = Object.assign({}, company)
      if (this.recordShow) {
        this.recordShow = false
      }
      setTimeout(() => {
        this.clueReportShow = true
      }, 500)
    },
  },
}
</script>

<style scoped lang="scss">
.prm-clue {
  padding-bottom: 70px;

  .cube {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 40px;
    background-color: #F3F4F6;
  }

  .company-box {
    line-height: 1;
  }

  .foot-menu {
    position: fixed;
    background-color: #fff;
    bottom: 0;
    left: 240px;
    width: calc(100% - 240px);
    z-index: 3;
    padding-left: 20px;
    padding: 4px 30px 5px 20px;

    &.active {
      left: 340px;
      width: calc(100% - 340px);
    }

    .f-table-footer {
      margin: 0;
      height: 50px;
    }
  }
}
</style>

<style>
.prm-clue-tooltip-description {
  max-width: 400px;
}
.prm-clue-tooltip-description .el-scrollbar {
  max-height: 400px;
}
.prm-clue-tooltip-description .el-scrollbar__wrap {
  max-height: 400px;
  overflow-x: hidden;
  padding-bottom: 10px;
}
</style>
